// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","713":"component---src-templates-using-dsg-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"2a73a1ef87a039ecd42f","678":"f16523d2d2d11031549a","713":"19869e2d81fb765cf5ce","883":"4e70feecbcd63b1a4960"}[chunkId] + ".js";
};